var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadiantBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 280,
    viewBox: "0 0 311 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_111_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93.604,
    cy: 93.604,
    r: 93.604,
    transform: "matrix(-1 0 0 1 187.268 92.7915)",
    fill: "url(#paint0_linear_111_4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.604,
    cy: 93.604,
    r: 93.104,
    transform: "matrix(-1 0 0 1 187.268 92.7915)",
    stroke: "url(#paint1_linear_111_4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_111_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.0462,
    cy: 55.0462,
    r: 55.0462,
    transform: "matrix(-1 0 0 1 310.864 0.515625)",
    fill: "url(#paint2_linear_111_4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.0462,
    cy: 55.0462,
    r: 54.5462,
    transform: "matrix(-1 0 0 1 310.864 0.515625)",
    stroke: "url(#paint3_linear_111_4)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_111_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5391,
    cy: 22.5391,
    r: 22.5391,
    transform: "matrix(-1 0 0 1 160.375 14.1445)",
    fill: "url(#paint4_linear_111_4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5391,
    cy: 22.5391,
    r: 22.0391,
    transform: "matrix(-1 0 0 1 160.375 14.1445)",
    stroke: "url(#paint5_linear_111_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_111_4",
    x: -21.7396,
    y: 70.9915,
    width: 230.808,
    height: 230.808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_111_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_111_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_111_4",
    x: 178.972,
    y: -21.2844,
    width: 153.692,
    height: 153.692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_111_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_111_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_111_4",
    x: 93.4964,
    y: -7.65547,
    width: 88.6781,
    height: 88.6781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_111_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_111_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_4",
    x1: 5.19939,
    y1: 33.8848,
    x2: 181.046,
    y2: 152.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#18DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32DFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_4",
    x1: 6.57858,
    y1: 20.0929,
    x2: 170.702,
    y2: 146.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204859,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629663,
    stopColor: "#666666",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_4",
    x1: 3.05763,
    y1: 19.9268,
    x2: 106.468,
    y2: 89.6784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#17DCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32DFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_4",
    x1: 3.8687,
    y1: 11.8162,
    x2: 100.385,
    y2: 86.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204859,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629663,
    stopColor: "#666666",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_111_4",
    x1: 1.25197,
    y1: 8.15917,
    x2: 43.5943,
    y2: 36.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AE732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#17DCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32DFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_111_4",
    x1: 1.58407,
    y1: 4.83821,
    x2: 41.1035,
    y2: 35.3911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204859,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629663,
    stopColor: "#666666",
    stopOpacity: 0.14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiantBubble);
export default __webpack_public_path__ + "static/media/radiant_bubble.b52f83fab62a77701f99c8f95fcd910d.svg";
export { ForwardRef as ReactComponent };